import { pillars } from './landingContent';

const DataPillars = () => (
  <section className="bl-features" id="features">
    <div className="bl-shell">
      <div className="bl-features__eyebrow">What BodyLytiX tracks</div>
      <h2 className="bl-features__title">
        Everything your body is telling you.<br />
        Finally in one place.
      </h2>
      <p className="bl-features__sub">
        Six data pillars that give you a complete, connected picture of your health - not just the easy metrics, but the ones that actually explain your performance.
      </p>
      <div className="bl-features__grid">
        {pillars.map((pillar) => (
          <article className="bl-feature-card" key={pillar.title}>
            <div className="bl-feature-card__icon" style={{ background: pillar.color }}>{pillar.icon}</div>
            <h3 className="bl-feature-card__title">{pillar.title}</h3>
            <p className="bl-feature-card__desc">{pillar.description}</p>
            <div className="bl-feature-card__tag">{pillar.meta}</div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default DataPillars;
